import React, { Component } from 'react'
import './About.css'
import './Signup.css'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import {db, authProvider} from '../firebase'

class Signup extends Component{
    state = {
        name: '',
        email: '',
        phone: '',
        address: '',
        password: '',
        age: '',
        message: 'Address required only if buying anything from the shop',
        err: false
    }
    signUp = (email , password, phone, address, name) => {
        authProvider.createUserWithEmailAndPassword(email, password).catch((err) => console.log(err)).then(() => {
            db.collection('users').add({
                userId : authProvider.currentUser.uid,
                email : email,
                phone: phone,
                address: address,
                name: name
            }).catch((err)=> console.log(err)).then(() => {
                this.props.history.push('/')
            })
        })
    }
    handleChange = (evt) => {
        this.setState({
            [evt.target.name] : evt.target.value
        })
    }
    handleSubmit = (evt) => {
        evt.preventDefault()
        this.validateForm()
    }
    validateForm = () => {
        if(!(this.state.phone.match(/^\d{10}$/))){
            this.setState({message : 'Enter valid phone number', err: true})
            return null
        }else{
            this.setState({message: '', err: false})
        }
        if(!this.state.name){
            this.setState({message : 'Name cannot be empty', err: true})
            return null
        }else{
            this.setState({message: '', err: false})
        }
        // eslint-disable-next-line
        if(!(this.state.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/))){
            this.setState({message : 'Enter valid email address', err: true})
            return null
        }else{
            this.setState({message: '', err: false})
        }
        if(!((this.state.age.match(/^\d{2}$/)))){
            this.setState({message : 'Enter valid age', err: true})
            return null
        }else{
            this.setState({message: '', err: false})
        }
        if(!(this.state.password.match(/^[A-Za-z]\w{7,14}$/))){
            this.setState({message : 'Enter valid password (7-15 characters with only characters, numeric digits or underscores)', err: true})
            return null
        }else{
            this.setState({message: '', err: false})
        }
        this.signUp(this.state.email, this.state.password, this.state.phone, this.state.address, this.state.name)
    }
    render() {
        return (
            <Container>
                <Row className="Signup-bottom Signup-head">
                    <Col xs={1} md={3}>
                    </Col>
                    <Col xs={10} md={6}>
                        <Row className="Signup-bg">
                            <Col>
                                <Row className="Signup-bottom">
                                    <Col className="Signup-title d-flex justify-content-center">
                                        Signup
                                    </Col>
                                </Row>
                                <Form onSubmit={this.handleSubmit}>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="name">
                                                <Form.Label>Name</Form.Label>
                                                <Form.Control type="string" name='name' value={this.state.name} placeholder="Enter name" onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="email">
                                                <Form.Label>Email Address</Form.Label>
                                                <Form.Control type="email" name='email' value={this.state.email} placeholder="Enter email address" onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="password">
                                                <Form.Label>password</Form.Label>
                                                <Form.Control type="password" name='password' value={this.state.password} placeholder="enter a password" onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="phone">
                                                <Form.Label>Phone Number</Form.Label>
                                                <Form.Control type="string" name='phone' value={this.state.phone} placeholder="Enter phone number" onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="age">
                                                <Form.Label>Age</Form.Label>
                                                <Form.Control type="string" name='age' value={this.state.age} placeholder="Enter Your Age" onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="address">
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control type="string" name='address' value={this.state.address} placeholder="Enter address" onChange={this.handleChange} />
                                                <Form.Text className="text-muted d-flex justify-content-center">
                                                    <span className={this.state.err ? "Signup-message-error" : "Signup-message"}>{this.state.message}</span>
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="Signup-button">
                                        <Col className="d-flex justify-content-center">
                                            <Button type="submit">Submit</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>    
                        </Row>     
                    </Col>
                    <Col xs={1} md={3}>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default Signup